const locale = {
  LOADER_TEXT: 'Cargando',
};

export default locale;
